/** `source` on `MoneyMapPublishedForPreview` / `MoneyMapFinalizedForAction` payloads (Mixpanel). */
export const MoneyMapPublishFinalizeEventSource = {
    /** Classic full-page money map editor (`MoneyMapPageWithHeader`). */
    EDITOR: 'money_map_editor',
    /** Visual money mapper (`MoneyMapperPage`). */
    MAPPER: 'money_map_mapper',
} as const;
